import { saveRedirectionIntoStorage } from "@/util/helpers/LoginRedirectionHelpers/LoginRedirectionHelpers";

export default function auth({
  nextMiddleware,
  router,
  store,
  newTo,
  from,
  contextNext,
}) {
  if (!store.state.auth.loggedIn) {
    saveRedirectionIntoStorage(newTo.fullPath);
    return contextNext({
      path: "/login",
    });
  } else {
    // console.log(store.state.auth.user.status)
    // if (
    //   store.state.auth.user &&
    //   (store.state.auth.user.observe_status == "rejected" ||
    //     store.state.auth.user.observe_status == "pending")
    // ) {
    //   return contextNext({
    //     path: "/register-forms",
    //   });
    // } 
    // else
    if (
      store.state.auth.user &&
      store.state.auth.user.observe_status != "active"
    ) {
      return contextNext({
        path: "/login",
      });
    }
    // else if (
    //   store.state.auth.user &&
    //   store.state.auth.user.status == "active" && (store.state.auth.user.assign_file_approval == "pending" ||
    //     store.state.auth.user.assign_file_approval == "incorrect")
    // ) {
    //   return contextNext({
    //     path: "/complete-register-forms",
    //   });
    // }
    store.dispatch("notifications/getNotifocations");
    return nextMiddleware();
  }
}
